import { useFlagOrganization } from './useFlagOrganization';

export default function useHigherEducationHomeUserUI() {
  const { isActive, isLoading } = useFlagOrganization({
    flag: 'NEW_HIGHER_EDUCATION_HOME_USER',
  });

  return isLoading || isActive;
}
